export enum FormMode {
  Create = 'create',
  Add = 'add',
  Edit = 'edit',
  Duplicate = 'duplicate',
  Copy = 'copy',
  CreateNextStep = 'createNextStep',
  Preview = 'preview',
}
